declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export function initAnalytics() {
}

export function identifyUser(email: string, properties?: Record<string, unknown>) {
  if (!window.gtag) return;
  window.gtag('set', { user_id: email });
  if (properties) {
    window.gtag('set', 'user_properties', properties);
  }
}

export function resetUser() {
  if (!window.gtag) return;
  window.gtag('set', { user_id: undefined });
}

export function capture(event: string, properties?: Record<string, unknown>) {
  if (!window.gtag) return;
  window.gtag('event', event, properties);
}
